import TargetCheckBox from '@components/common/checkbox/TargetCheckBox';
import RealTimeSearch from '@components/common/RealTimeSearch';
import Modal from '@components/modal/Modal';
import { MODAL_SIZE_VAR } from '@consts/ModalSizeVar';
import { useAddChannelModal } from '@components/channelList/hooks/useAddChannelModal';
import * as SC from '@components/channelList/modal/AddChannelModal.style';
import strings from '@i18n/index';
import EmptySearchResult from '@components/common/empty/EmptySearchResult';
import { useRef } from 'react';
import { AvatarInner } from '@sendbird/uikit-react/ui/Avatar';

export type AddChannelModalProps = {
  [x: string]: any;
};

const AddChannelModal = () => {
  const {
    theme,
    userList,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    searchName,
    selectedIds,
    selectedUsers,
    resetLabel,
    hasScroll,
    scrollRef,
    targetObserverRef,
    closeModalHandler,
    confirmModalHandler,
    changeInputHandler,
    resetInputHandler,
    selectTargetUserHandler,
    resetTargetUserHandler,
    renderSelectedUserChips,
  } = useAddChannelModal();

  const modalRef = useRef<HTMLDivElement>(null);
  const resultRenderComponent = renderSelectedUserChips(selectedUsers);
  const pathUrl = import.meta.env.VITE_APP_API_URL;

  return (
    <Modal
      ref={modalRef}
      title={strings.INVITE__MEMBER_SELECTION}
      width={MODAL_SIZE_VAR.XS}
      confirmText={strings.INVITE__CREATE}
      resetLabel={selectedIds.length > 0 ? resetLabel : ''}
      onCancel={closeModalHandler}
      onConfirm={confirmModalHandler}
      onReset={resetTargetUserHandler}
      disabled={selectedIds.length === 0}
    >
      <>
        {selectedUsers.length > 0 && <SC.SelectedChipsBox>{resultRenderComponent}</SC.SelectedChipsBox>}
        <SC.InnerBox>
          <SC.SearchBox>
            <RealTimeSearch value={searchName} onChange={changeInputHandler} onDelete={resetInputHandler} />
          </SC.SearchBox>

          <SC.ListBox>
            <SC.ScrollComponent
              ref={scrollRef}
              className='custom-scroll-component'
              maxHeight={728}
              filterMaxHeight={selectedUsers.length > 0 ? '68px' : '0px'}
              hasScroll={hasScroll}
            >
              {userList && userList?.length > 0 ? (
                <div>
                  {userList.map((user, index) => (
                    <TargetCheckBox
                      key={`userItem__${user.userId}${index}`}
                      targetValue={user.userId}
                      checked={selectedIds.includes(user.userId)}
                      disabled={user.isAuth === '0'}
                      onChange={() => selectTargetUserHandler(user)}
                    >
                      <SC.UserInfoItem disabled={user.isAuth === '0'}>
                        <SC.AvatarWrapper>
                          <AvatarInner
                            width='32px'
                            height='32px'
                            src={user.userRegImg && `${pathUrl}${user.userRegImg}`}
                          />
                        </SC.AvatarWrapper>
                        <SC.InfoBox title={user.userName}>
                          <SC.MainData>{user.userName}</SC.MainData>
                          {user?.groupName && <SC.SubData mode={theme}>{user?.groupName}</SC.SubData>}
                        </SC.InfoBox>
                      </SC.UserInfoItem>
                    </TargetCheckBox>
                  ))}
                  {!isFetchingNextPage && hasNextPage && <div ref={targetObserverRef} style={{ height: '10px' }} />}
                </div>
              ) : !isLoading && !searchName ? (
                <div className='loading'>로딩중...</div>
              ) : searchName.length > 0 ? (
                <EmptySearchResult marginTop='14%' />
              ) : (
                <></>
              )}
            </SC.ScrollComponent>
          </SC.ListBox>
        </SC.InnerBox>
      </>
    </Modal>
  );
};

export default AddChannelModal;
